module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.$route.meta.belong !== 'air-service' ? 'dhr' : 'air-service'],
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "navigation"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    class: [_vm.$route.meta.belong === 'air-service' ? 'air-service-container' : 'dhr-container']
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view', {
    class: [_vm.$route.meta.belong === 'air-service' ? 'air-service-container' : 'dhr-container']
  }) : _vm._e()], 1), _vm._v(" "), _c('dialogs')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7d7c370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1410
// module chunks = 107